import React from 'react';

import { Grid, normalizeSelectValue } from '@gogame/components';
import {
  FormField,
  useSiblingFieldName,
  withFormFieldGroupFormField,
} from '@gogame/form';

import { CREATIVES_TARGET } from 'scenes/SmartRules/SmartRuleForm/constants';
import {
  loadConceptCreationPeriods,
  loadCreativeCreationPeriods,
  loadCreativeTypes,
  loadLanguages,
  loadMediaTypes,
  loadOrientations,
  loadTags,
  loadStatuses,
} from 'scenes/SmartRules/sources/fields';

import {
  CONCEPT_CREATION_PERIOD,
  CREATIVE_CREATION_PERIOD,
  CREATIVE_TYPES,
  LANGUAGES,
  MEDIA_TYPES,
  ORIENTATIONS,
  TAGS,
  STATUSES,
} from './constants';
import { validationSchema } from './schema';

const normalizeCreationPeriod = (value, data) =>
  normalizeSelectValue(value, data);

export const CreativesPopulations = withFormFieldGroupFormField({
  name: CREATIVES_TARGET,
  validationSchema: validationSchema,
})(() => {
  const getSiblingFieldName = useSiblingFieldName();

  return (
    <Grid container spacing={3}>
      <Grid item xs={4}>
        <FormField.Select
          label={'Concept added'}
          placeholder={'All'}
          name={CONCEPT_CREATION_PERIOD}
          source={loadConceptCreationPeriods}
          normalizeValue={normalizeCreationPeriod}
          padding={0}
          _cleanOnUnmount={true}
          canDeselect={true}
        />
      </Grid>
      <Grid item xs={4}>
        <FormField.Select
          label={'Creative added'}
          placeholder={'All'}
          name={CREATIVE_CREATION_PERIOD}
          source={loadCreativeCreationPeriods}
          normalizeValue={normalizeCreationPeriod}
          padding={0}
          _cleanOnUnmount={true}
          canDeselect={true}
        />
      </Grid>
      <Grid item xs={4}>
        <FormField.MultiSelect
          label={'Languages'}
          placeholder={'All'}
          name={LANGUAGES}
          source={loadLanguages}
          lazy={true}
          padding={0}
          _cleanOnUnmount={true}
        />
      </Grid>
      <Grid item xs={4}>
        <FormField.MultiSelect
          label={'Creative types'}
          placeholder={'All'}
          name={CREATIVE_TYPES}
          source={loadCreativeTypes}
          depends={[getSiblingFieldName(MEDIA_TYPES)]}
          lazy={true}
          padding={0}
          _cleanOnUnmount={true}
        />
      </Grid>
      <Grid item xs={4}>
        <FormField.MultiSelect
          label={'Media Types'}
          placeholder={'All'}
          name={MEDIA_TYPES}
          source={loadMediaTypes}
          depends={[getSiblingFieldName(CREATIVE_TYPES)]}
          lazy={true}
          padding={0}
          _cleanOnUnmount={true}
        />
      </Grid>
      <Grid item xs={4}>
        <FormField.MultiSelect
          label={'Orientations'}
          placeholder={'All'}
          name={ORIENTATIONS}
          source={loadOrientations}
          lazy={true}
          padding={0}
          _cleanOnUnmount={true}
        />
      </Grid>
      <Grid item xs={4}>
        <FormField.MultiSelect
          label={'Tags'}
          placeholder={'All'}
          name={TAGS}
          source={loadTags}
          lazy={true}
          padding={0}
          _cleanOnUnmount={true}
        />
      </Grid>
      <Grid item xs={4}>
        <FormField.MultiSelect
          label={'Statuses'}
          placeholder={'All'}
          name={STATUSES}
          source={loadStatuses}
          lazy={true}
          padding={0}
          _cleanOnUnmount={true}
        />
      </Grid>
    </Grid>
  );
});
